"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lottieWeb = _interopRequireDefault(require("lottie-web"));
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var RenderAnimation = function RenderAnimation(_ref) {
  var _ref$animationJSON = _ref.animationJSON,
    animationJSON = _ref$animationJSON === void 0 ? null : _ref$animationJSON,
    _ref$animationName = _ref.animationName,
    animationName = _ref$animationName === void 0 ? '' : _ref$animationName,
    _ref$animationDivId = _ref.animationDivId,
    animationDivId = _ref$animationDivId === void 0 ? '' : _ref$animationDivId,
    _ref$preserveAspectRa = _ref.preserveAspectRatio,
    preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'none' : _ref$preserveAspectRa,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? true : _ref$loop;
  (0, _react.useEffect)(function () {
    _lottieWeb["default"].loadAnimation({
      container: document.getElementById(animationDivId),
      animationData: animationJSON,
      loop: loop,
      renderer: 'svg',
      name: animationName,
      rendererSettings: {
        preserveAspectRatio: preserveAspectRatio
      }
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-sentry-component": "RenderAnimation",
    "data-sentry-source-file": "RenderAnimation.tsx"
  });
};
var _default = exports["default"] = RenderAnimation;